export default "__VITE_ASSET__BWfLPB4y__"